
    import { Cascader } from '@alifd/next';
    import type { CascaderProps } from '@alifd/next/types/cascader';
    import wrapper from './next-wrapper';

    export type BLProFormCascaderProps =CascaderProps;

    const BLProFormCascader = wrapper<BLProFormCascaderProps>(Cascader, 'BLProFormCascader');

    export default BLProFormCascader;
